function rowToRecord(columnNames, row) {
    const record = {};
    columnNames.forEach((name, idx) => (record[name] = row[idx]));
    return record;
}
/**
 * Creates a query result by mapping raw rows to JavaScript.
 *
 * This should not be used with libraries doing this mapping natively, as that is typically more performant.
 *
 * @public
 */
export function queryResultFromRaw(raw) {
    const { insertId, rowsAffected, columnNames, rawRows } = raw;
    let array;
    function loadAsArray() {
        if (array)
            return array;
        return (array = rawRows.map((row) => rowToRecord(columnNames, row)));
    }
    function getRow(idx) {
        if (array)
            return array[idx];
        return rowToRecord(columnNames, rawRows[idx]);
    }
    return {
        insertId,
        rowsAffected,
        get array() {
            return loadAsArray();
        },
        rows: {
            length: rawRows.length,
            get _array() {
                return loadAsArray();
            },
            item: getRow
        },
        [Symbol.iterator]() {
            let nextIndex = 0;
            return {
                next: function () {
                    if (nextIndex >= rawRows.length) {
                        return { done: true, value: undefined };
                    }
                    const row = getRow(nextIndex);
                    nextIndex++;
                    return { done: false, value: row };
                }
            };
        }
    };
}
/**
 * Creates a query result from rows that have already been mapped to JavaScript.
 *
 * @public
 */
export function queryResultFromMapped(base, rows) {
    if (rows == null)
        return queryResultWithoutRows(base);
    return {
        insertId: base.insertId,
        rowsAffected: base.rowsAffected,
        array: rows ?? [],
        rows: {
            length: rows.length,
            _array: rows,
            item(i) {
                return rows[i];
            }
        },
        [Symbol.iterator]() {
            return rows[Symbol.iterator]();
        }
    };
}
/**
 * Creates a {@link QueryResult} not containing any rows.
 *
 * @public
 */
export function queryResultWithoutRows(result) {
    return {
        ...result,
        array: [],
        [Symbol.iterator]() {
            return {
                next() {
                    return { done: true, value: undefined };
                }
            };
        }
    };
}
//# sourceMappingURL=QueryResult.js.map